export const toNumber = (value: false | null | number | string | undefined, min = 0) =>
  value ? (isNaN(+value) || !isFinite(+value) ? min : +value) : min;
